module.exports = __webpack_public_path__ + "static/media/Untitled design (4).986a3739.png";